import {NgModule} from '@angular/core'
import {RouterModule} from '@angular/router'
import {MatLegacyButtonModule as MatButtonModule} from '@angular/material/legacy-button'
import {MatIconModule} from '@angular/material/icon'
import {CommonModule} from '@angular/common';
import {ZbiorUszkodzenComponent} from './zbior-uszkodzen.component';
import {UszkodzenieComponent} from './uszkodzenie/uszkodzenie.component';
import {StrategiaInneComponent} from './uszkodzenie/strategia/strategia-inne.component';
import {StrategiaDodatkowyPrzedmiotComponent} from './uszkodzenie/strategia/strategia-dodatkowy-przedmiot.component';
import { StrategiaMaterialWartoscComponent } from './uszkodzenie/strategia/strategia-material-wartosc.component';
import {StrategiaRodzajMaterialWartoscComponent} from './uszkodzenie/strategia/strategia-rodzaj-material-wartosc.component';
import {StrategiaMaterialWymiaryWartoscComponent} from './uszkodzenie/strategia/strategia-material-wymiary-wartosc.component';
import {StrategiaDirective} from './uszkodzenie/strategia/strategia.directive';
import {StrategiaPodsumowaniaUszkodzenComponent
} from './uszkodzenie/strategia/strategia-podsumowania-uszkodzen.component';
import {StrategiaIloscComponent} from './uszkodzenie/strategia/strategia-ilosc.component';
import {StrategiaWymiaryComponent} from './uszkodzenie/strategia/strategia-wymiary.component';
import {StrategiaDefaultComponent} from './uszkodzenie/strategia/strategia-default.component';
import {StrategiaWartoscComponent} from './uszkodzenie/strategia/strategia-wartosc.component';
import {PodsumowanieZUszkodzeniemComponent} from './podsumowanie/z-uszkodzeniem/podsumowanie-z-uszkodzeniem.component';
import {PodsumowanieBezUszkodzeniaComponent} from './podsumowanie/bez-uszkodzen/podsumowanie-bez-uszkodzenia.component';

@NgModule({
  declarations: [
    ZbiorUszkodzenComponent,
    PodsumowanieZUszkodzeniemComponent,
    PodsumowanieBezUszkodzeniaComponent,
    UszkodzenieComponent,
    StrategiaPodsumowaniaUszkodzenComponent,
    StrategiaIloscComponent,
    StrategiaInneComponent,
    StrategiaDodatkowyPrzedmiotComponent,
    StrategiaWymiaryComponent,
    StrategiaDefaultComponent,
    StrategiaWartoscComponent,
    StrategiaMaterialWartoscComponent,
    StrategiaRodzajMaterialWartoscComponent,
    StrategiaMaterialWymiaryWartoscComponent,
    StrategiaDirective
  ],
  imports: [RouterModule, MatButtonModule, MatIconModule, CommonModule],
  exports: [ZbiorUszkodzenComponent]
})
export class ZbiorUszkodzenModule {

}
